import Vue from 'vue';
import Component from 'vue-class-component';

import getParticipantsIcon from 'common/services/utils/getParticipantsIcon';

@Component({
  props: {
    activity: {
      type: Object,
      requried: true,
    },
    currentStep: {
      type: String,
      required: false,
      default: null,
    },
    selectedParticipantsQuantity: {
      type: Number,
      required: false,
      default: null,
    },
    codeId: {
      type: Number,
      required: false,
    },
  },
})
export default class CatalogReservationConfigHeaderComponent extends Vue {
  get participantsIcon() {
    return getParticipantsIcon(this.activity.participants);
  }

  get isMultipleParticipantsEnabled() {
    return (
      this.activity?.participants_options &&
      Array.isArray(this.activity.participants_options) &&
      this.activity.participants_options.length > 1 &&
      !this.codeId
    );
  }

  get shouldShowParticipants() {
    // Si está habilitada la venta múltiple Y estamos en el step de selección,
    // NO mostrar NUNCA (independientemente de si hay cantidad seleccionada)
    return !(
      this.isMultipleParticipantsEnabled &&
      this.currentStep === 'select-location-date'
    );
  }

  get participantsToShow() {
    // Si está en el step de selección y hay cantidad seleccionada, mostrar esa cantidad
    if (
      this.isMultipleParticipantsEnabled &&
      this.selectedParticipantsQuantity
    ) {
      // selectedParticipantsQuantity es la cantidad de actividades
      // Multiplicar por activity.participants para obtener el total de personas
      return this.selectedParticipantsQuantity * this.activity.participants;
    }
    // En cualquier otro caso, mostrar activity.participants
    return this.activity.participants;
  }
}
